import { copy } from "shared/assets";
import { Edit, Stop } from "shared/assets/icons";
import { IActionDropdownItem } from "shared/components";
import { IStatus } from "shared/types";

const { actions: actionsCopy } = copy;

export const getBandSummaryActions = ({
  handleEdit,
  handleDelete,
}: {
  handleEdit?: () => void;
  handleDelete: () => void;
}): IActionDropdownItem[] => {
  let actions: IActionDropdownItem[] = [];

  handleEdit &&
    actions.push({
      label: actionsCopy.edit,
      icon: Edit,
      handleClick: handleEdit,
      dataTestId: "edit_band",
    });

  handleDelete &&
    actions.push({
      label: actionsCopy.delete,
      icon: Stop,
      handleClick: handleDelete,
      dataTestId: "delete_band",
      status: IStatus.error,
    });

  return actions;
};
